import { render, staticRenderFns } from "./deliveryRecord.vue?vue&type=template&id=20470ada&scoped=true&"
import script from "./deliveryRecord.vue?vue&type=script&lang=js&"
export * from "./deliveryRecord.vue?vue&type=script&lang=js&"
import style0 from "./deliveryRecord.vue?vue&type=style&index=0&id=20470ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20470ada",
  null
  
)

export default component.exports